import request from './request'
import { INVOICE_LIST_URL, INVOICE_SUBMIT_URL } from './config'

/**
 * 获取可开票列表（分页）
 * @param {number} fromIndex 页码
 * @param {number} pageSize 每页数量
 * @returns {Promise<{ list: Array, total: number }>}
 */
export async function getInvoiceList (fromIndex, pageSize) {
  const params = {}
  if (typeof fromIndex === 'number') params.fromIndex = fromIndex
  if (typeof pageSize === 'number') params.pageSize = pageSize

  try {
    const data = await request.post(INVOICE_LIST_URL, params)
    let list = []
    let total = 0

    if (Array.isArray(data)) {
      list = data
    } else if (data) {
      if (Array.isArray(data.list)) {
        list = data.list
      } else if (Array.isArray(data.data)) {
        list = data.data
      }
      if (typeof data.total === 'number') {
        total = data.total
      }
    }

    if (total === 0 && Array.isArray(list)) {
      total = list.length
    }

    return { list, total }
  } catch (err) {
    return { list: [], total: 0 }
  }
}

/**
 * 提交开具发票
 * @param {Object} payload - { title: 抬头, taxNo: 税号, email: 邮箱, ids: 选中的列表项 id 数组 }
 * @returns {Promise<Object>}
 */
export function submitInvoice (payload) {
  return request.post(INVOICE_SUBMIT_URL, payload || {})
}
